import type { ValidationIssue } from "@/hooks/use-inline-validation";

export function FieldError({ id, message }: { id: string; message?: string }) {
  return (
    <p
      id={id}
      className="max-w-full break-words text-[0.875rem] font-semibold leading-snug text-destructive empty:hidden"
    >
      {message}
    </p>
  );
}

/**
 * Announces the whole error set once per submit attempt and gives keyboard and
 * screen reader users a direct path back to each invalid control.
 */
export function ValidationSummary({
  issues,
  onJump,
}: {
  issues: ValidationIssue[];
  onJump: (name: string) => void;
}) {
  return (
    <div aria-live="assertive" aria-atomic="true">
      {issues.length > 0 ? (
        <div
          role="alert"
          className="rounded-sm border border-destructive/50 bg-destructive/5 p-4 text-left"
        >
          <p className="text-[0.9375rem] font-bold text-destructive">
            {issues.length === 1
              ? "1 field needs your attention"
              : `${issues.length} fields need your attention`}
          </p>
          <ul className="mt-2 space-y-1">
            {issues.map((issue) => (
              <li key={issue.name}>
                <button
                  type="button"
                  onClick={() => onJump(issue.name)}
                  className="max-w-full break-words text-left text-[0.875rem] font-semibold text-destructive underline underline-offset-4 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-destructive focus-visible:ring-offset-2"
                >
                  {issue.label}: {issue.message}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
